export const FETCH_ACD_DAILY_TOTAL_REPORT = "FETCH_ACD_DAILY_TOTAL_REPORT";
export const FETCH_ACD_DAILY_TOTAL_REPORT_SUCCESS = "FETCH_ACD_DAILY_TOTAL_REPORT_SUCCESS";
export const FETCH_ACD_DAILY_TOTAL_REPORT_FAILURE = "FETCH_ACD_DAILY_TOTAL_REPORT_FAILURE";

export const FETCH_ACD_DAILY_QUEUE_REPORT = "FETCH_ACD_DAILY_QUEUE_REPORT";
export const FETCH_ACD_DAILY_QUEUE_REPORT_SUCCESS = "FETCH_ACD_DAILY_QUEUE_REPORT_SUCCESS";
export const FETCH_ACD_DAILY_QUEUE_REPORT_FAILURE = "FETCH_ACD_DAILY_QUEUE_REPORT_FAILURE";


export const SHOW_LOADER = 'SHOW_LOADER';
export const HIDE_LOADER = 'HIDE_LOADER';
export const SHOW_SNACKBAR = 'SHOW_SNACKBAR';

export const FETCH_ACD_MONTHLY_TOTAL_REPORT = 'FETCH_ACD_MONTHLY_TOTAL_REPORT';
export const FETCH_ACD_MONTHLY_TOTAL_REPORT_SUCCESS = 'FETCH_ACD_MONTHLY_TOTAL_REPORT_SUCCESS';
export const FETCH_ACD_MONTHLY_TOTAL_REPORT_FAILURE = 'FETCH_ACD_MONTHLY_TOTAL_REPORT_FAILURE';

export const FETCH_ACD_TOTAL_DASHBOARD_REPORT = "FETCH_ACD_TOTAL_DASHBOARD_REPORT";
export const FETCH_ACD_TOTAL_DASHBOARD_REPORT_SUCCESS = "FETCH_ACD_TOTAL_DASHBOARD_REPORT_SUCCESS";
export const FETCH_ACD_TOTAL_DASHBOARD_REPORT_FAILURE = "FETCH_ACD_TOTAL_DASHBOARD_REPORT_FAILURE";

export const FETCH_ACD_JOB_LOGS = "FETCH_ACD_JOB_LOGS";
export const FETCH_ACD_JOB_LOGS_SUCCESS = "FETCH_ACD_JOB_LOGS_SUCCESS";
export const FETCH_ACD_JOB_LOGS_FAILURE = "FETCH_ACD_JOB_LOGS_FAILURE";

export const FETCH_ACD_JOB_LOG_DETAILS = "FETCH_ACD_JOB_LOG_DETAILS";
export const FETCH_ACD_JOB_LOG_DETAILS_SUCCESS = "FETCH_ACD_JOB_LOG_DETAILS_SUCCESS";
export const FETCH_ACD_JOB_LOG_DETAILS_FAILURE = "FETCH_ACD_JOB_LOG_DETAILS_FAILURE";
